module.exports = __webpack_public_path__ + "img/motorcycle-photo-03.335a620e.jpg";